import React, { useState } from 'react';
import { ContentDiv, FlexWrapper } from './AnalyzeClientData.styles';
import UploadData from './UploadData/UploadData';
import EditData from './EditData/EditData';
import { ApButtonTab } from '@alixpartners/ui-components';
import { ClientDataUploadHistoryProvider } from 'contexts/SupplierDiversity/ClientDataUploadHistoryProvider';
import DiversityStats from './DiversityStats/DiversityStats';
import PeriodSelect from 'Investigate/SecondaryNav/PeriodSelect';

const INITIAL_CLINET_DATA_NAV_CONFIG = [
	{
		id: 1,
		name: 'analyze-edit-data',
		label: 'Analyze/Edit Data',
		isActive: true,
		component: EditData,
	},

	{
		id: 3,
		name: 'supplier-diversity-stats',
		label: 'Supplier Diversity Stats',
		isActive: false,
		component: DiversityStats,
	},
	{
		id: 2,
		name: 'upload-data',
		label: 'Upload Data',
		isActive: false,
		component: UploadData,
	},
];

const AnalyzeClientData = props => {
	const [subNav, setSubNav] = useState(INITIAL_CLINET_DATA_NAV_CONFIG);

	const subNavHandler = value => {
		setSubNav(prevState =>
			prevState.map(el => {
				if (el.id === value) {
					return { ...el, isActive: true };
				} else {
					return { ...el, isActive: false };
				}
			})
		);
	};

	return (
		<>
			<FlexWrapper>
				<div>
					{subNav.map(({ id, name, label, isActive }) => (
						<ApButtonTab
							key={`${id}_${name}`}
							name={name}
							isSelected={isActive}
							onClick={() => subNavHandler(id)}
						>
							{label}
						</ApButtonTab>
					))}
				</div>
				{(subNav[0].isActive || subNav[1].isActive) && (
					<>
						<PeriodSelect />
					</>
				)}
			</FlexWrapper>
			<ClientDataUploadHistoryProvider>
				<ContentDiv>
					{subNav.map(({ id, isActive, component: Component }) => {
						return isActive && <Component key={id} {...props} />;
					})}
				</ContentDiv>
			</ClientDataUploadHistoryProvider>
		</>
	);
};

export default AnalyzeClientData;
